module.exports = __webpack_public_path__ + "static/media/home.3d673581.svg";